import { useQuasar } from 'quasar';
import { api } from 'boot/axios';

interface UnlockedAchievement {
  id: string;
  name: string;
  greekName: string | null;
  description: string;
  icon: string | null;
  xpReward: number;
}

interface NewCollectible {
  id: string;
  name: string;
  rankTitle: string | null;
}

interface CheckResponse {
  newlyUnlocked: UnlockedAchievement[];
  newCollectibles: NewCollectible[];
}

export function useAchievementToast() {
  const $q = useQuasar();

  async function checkAndNotify(): Promise<CheckResponse> {
    try {
      const { data } = await api.post<CheckResponse>('/gamification/check');

      // Show toast for each newly unlocked achievement
      for (const achievement of data.newlyUnlocked) {
        $q.notify({
          type: 'positive',
          position: 'top',
          timeout: 5000,
          message: `Logro desbloqueado: ${achievement.name}`,
          caption: `${achievement.greekName ?? ''} — +${achievement.xpReward} AURA`,
          icon: 'emoji_events',
          color: 'warning',
          textColor: 'dark',
          classes: 'achievement-toast',
          actions: [{ icon: 'close', color: 'dark', round: true }],
        });
      }

      // Show toast for each newly earned collectible
      for (const collectible of data.newCollectibles) {
        $q.notify({
          type: 'positive',
          position: 'top',
          timeout: 4000,
          message: `Coleccionable obtenido: ${collectible.name}`,
          caption: collectible.rankTitle ?? '',
          icon: 'stars',
          color: 'accent',
        });
      }

      return data;
    } catch {
      // Silent fail — achievement check is non-critical
      return { newlyUnlocked: [], newCollectibles: [] };
    }
  }

  return { checkAndNotify };
}
